import { DEFAULT_FORMATTER_LOCALE } from '../../constants/defaultFormatterLocale'
import { getFormatLocale } from '../getFormatLocale'

// en_US defaults to MM/DD/YYYY and a 12-hour clock; we want English to match every
// other supported language (DD/MM/YYYY, 24-hour), so we swap it for en-GB here.
const dateFormatLocaleOverrides = new Map<string, string>([['en_US', 'en-GB']])

export const getDateTime = (locale?: string, options?: Intl.DateTimeFormatOptions) => {
  const resolvedLocale = locale || DEFAULT_FORMATTER_LOCALE
  const intlLocale = dateFormatLocaleOverrides.get(resolvedLocale) ?? getFormatLocale(resolvedLocale)

  return new Intl.DateTimeFormat(intlLocale, options)
}
